import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin, Anchor } from 'lucide-react';
import { useI18n } from '@/i18n/I18nContext';
import { FOOTER } from '@/constants/testIds';

const LOGO_URL = '/assets/stc-logo.png';
const LINKEDIN_URL = 'https://www.linkedin.com/company/stc-marine-services/';

export const Footer = () => {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-[#050D17] border-t border-[#C9A24E]/20"
    >
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="mb-5">
              <img src={LOGO_URL} alt="STC Marine Services" className="h-32 w-auto object-contain" />
            </div>
            <p className="text-sm text-[#8F9BB3] max-w-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#C9A24E] mb-4">
              {t('footer.quickLinks')}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-[#F2F5F8]/80 hover:text-[#C9A24E] transition-colors">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-[#F2F5F8]/80 hover:text-[#C9A24E] transition-colors">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <a href="/#about" className="text-[#F2F5F8]/80 hover:text-[#C9A24E] transition-colors">
                  {t('nav.about')}
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-[#F2F5F8]/80 hover:text-[#C9A24E] transition-colors">
                  {t('nav.contact')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#C9A24E] mb-4">
              {t('footer.contactHeading')}
            </div>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  data-testid={FOOTER.emailLink}
                  href="mailto:info@stcmarineservices.com"
                  className="inline-flex items-center gap-3 text-[#F2F5F8]/85 hover:text-[#C9A24E] transition-colors"
                >
                  <Mail size={16} className="text-[#C9A24E]" />
                  info@stcmarineservices.com
                </a>
              </li>
              <li>
                <a
                  data-testid={FOOTER.phoneLink}
                  href="tel:+306973667473"
                  className="inline-flex items-center gap-3 text-[#F2F5F8]/85 hover:text-[#C9A24E] transition-colors"
                >
                  <Phone size={16} className="text-[#C9A24E]" />
                  +30 6973667473
                </a>
              </li>
              <li>
                <a
                  data-testid={FOOTER.linkedin}
                  href={LINKEDIN_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 text-[#F2F5F8]/85 hover:text-[#C9A24E] transition-colors"
                  aria-label="STC Marine Services on LinkedIn"
                >
                  <Linkedin size={16} className="text-[#C9A24E]" />
                  LinkedIn
                </a>
              </li>
              <li className="flex items-start gap-3 text-[#F2F5F8]/85">
                <Anchor size={16} className="text-[#C9A24E] mt-1 shrink-0" />
                <div>
                  <div>Capt. Stylianos Chatzigiakoumis</div>
                  <div className="text-[10px] uppercase tracking-[0.24em] text-[#8F9BB3] mt-1">
                    Founder &amp; Principal Auditor
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[#C9A24E]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-[#8F9BB3]">
          <span>© {year} STC Marine Services. {t('footer.rights')}</span>
          <span className="tracking-[0.22em] uppercase">Maritime Consultancy · Surveys · Audits</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
